import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.object.define-property.js";

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/_createClass(function _default(callback, delay) {
  var _this = this;

  _classCallCheck(this, _default);

  _defineProperty(this, "start", function () {
    _this.startTime = Date.now();
    _this.timerId = setTimeout(_this.callback, _this.remaining);
  });

  _defineProperty(this, "pause", function () {
    clearTimeout(_this.timerId);
    _this.remaining -= Date.now() - _this.startTime;
  });

  _defineProperty(this, "clear", function () {
    clearTimeout(_this.timerId);
  });

  this.timerId = null;
  this.startTime = 0;
  this.remaining = delay;
  this.callback = callback;
});

export { _default as default };